/** @format */

import axios from "axios";
import {getCookie} from "../../untils/helpers";
/**
 * create axios
 * @type {AxiosInstance}
 */
// NEXT_PUBLIC_BASE_URL
// use for login, profile

const instance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL_API,
    headers: {
        deviceType: "4",
        appVersion: "",
        privateKey: "M0ch1M0ch1_Jp_$ecret_k3y",
        "Content-Type": "application/json",
        // Authorization: "Bearer " + getCookie("user_token")
    },
    timeout: 5000,
});

// Hàm setter để đặt giá trị Authorization
export const setAuthorizationHeader = (userToken) => {
    instance.defaults.headers.common['Authorization'] = `Bearer ${getCookie("user_token")}`;
};

export const post = async (url, data) => {
    return await instance.post(url, data);
};
export const get = async (url, data) => {
    // let customInstance = instance;
    // customInstance.headers['Authorization'] = `Bearer ${data}`
    const params = new URLSearchParams(data);
    return await instance.get(url, { params });
};
